import { render, staticRenderFns } from "./ico_icon.vue?vue&type=template&id=b0d3c270&"
import script from "./ico_icon.vue?vue&type=script&lang=js&"
export * from "./ico_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports